<template>
  <vx-card id="card-vessel-report" v-if="reportDetails">
    <vs-row vs-type="flex" class="mt-4 mb-4">
      <vs-col
        vs-order="1"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="2"
      >
        <span class="report-heading-1-text">
          ID
        </span>
      </vs-col>
      <vs-col
        vs-order="2"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="8"
      >
        <span class="report-body-text">
          {{ reportId }}
        </span>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" class="mt-4 mb-4">
      <vs-col
        vs-order="1"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="2"
      >
        <span class="report-heading-1-text">
          船名
        </span>
      </vs-col>
      <vs-col
        vs-order="2"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="10"
      >
        <span class="report-vessel-name">{{
          reportDetails.vessel.name_ja
        }}</span>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" class="mt-4 mb-8">
      <vs-col
        vs-order="1"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="2"
      >
        <span class="report-heading-1-text">
          連絡時間
        </span>
      </vs-col>
      <vs-col
        vs-order="2"
        vs-type="flex"
        vs-justify="start"
        vs-align="center"
        vs-w="10"
      >
        <span class="report-body-text">
          {{ toYMD(reportDetails.report_at) }}
        </span>
      </vs-col>
    </vs-row>

    <vs-row class="mb-4">
      <!-- コンテナ -->
      <vs-col id="item-timeline" vs-lg="8" vs-sm="12">
        <vx-card :noShadow="true">
          <report-timeline />
        </vx-card>
      </vs-col>
      <!-- 海況 -->
      <vs-col vs-lg="4" vs-sm="12">
        <vx-card id="item-sea-conditions" :noShadow="true">
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-2-text">
                海況
              </span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-1-text">天候</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-body-text">{{ reportDetails.weather }}</span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-1-text">風向</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <div class="report-body-text">
                <span v-if="reportDetails.wind_direction">{{
                  reportDetails.wind_direction
                }}</span>
                <span v-else>---</span>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-1-text">風力</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <div class="report-body-text">
                <span v-if="reportDetails.wind_strength !== null"
                  >{{ Math.round(reportDetails.wind_strength * 100) / 100 }} m/s</span
                >
                <span v-else>---</span>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-1-text">波高</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <div class="report-body-text">
                <span v-if="reportDetails.wave_height !== null"
                  >{{ Math.round(reportDetails.wave_height * 100) / 100 }} m</span
                >
                <span v-else>---</span>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-1-text">うねり</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <div class="report-body-text">
                <span v-if="reportDetails.swell !== null"
                  >{{ Math.round(reportDetails.swell * 100) / 100 }} m</span
                >
                <span v-else>---</span>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-1-text">視程</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <div class="report-body-text">
                <span v-if="reportDetails.visibility !== null"
                  >{{Math.round(this.reportDetails.visibility * 100 / 1852) / 100 }} NM</span
                >
                <span v-else>---</span>
              </div>
            </vs-col>
          </vs-row>
        </vx-card>
      <!-- 運転状況 -->
        <vx-card id="item-crew-conditions" :noShadow="true">
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="12" vs-sm="12" vs-xs="12"
            >
              <span class="report-heading-2-text">
                運転状況
              </span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-1-text">船首</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <div class="report-body-text">
                <span v-if="reportDetails.heading !== null"
                  >{{ Math.round(reportDetails.heading * 100) / 100 }} ˚</span
                >
                <span v-else>---</span>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-1-text">速力</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <div class="report-body-text">
                <span v-if="reportDetails.velocity !== null"
                  >{{
                    Math.round(this.reportDetails.velocity * 10) / 10
                  }}
                  kt</span
                >
                <span v-else>---</span>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-1-text">CPP</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <div class="report-body-text">
                <span v-if="reportDetails.cpp !== null">{{ Math.round(reportDetails.cpp * 100) / 100 }} ˚</span>
                <span v-else>---</span>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-1-text">RPM</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <div class="report-body-text">
                <span v-if="reportDetails.rpm !== null"
                  >{{ Math.round(reportDetails.rpm * 100) / 100 }} / min</span
                >
                <span v-else>---</span>
              </div>
            </vs-col>
          </vs-row>
        </vx-card>

      <!-- 船員 -->
        <vx-card id="item-crew-conditions" :noShadow="true">
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="12" vs-sm="12" vs-xs="12"
            >
              <span class="report-heading-2-text">
                船員
              </span>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-1-text">乗組人数</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <div class="report-body-text">
                <span v-if="reportDetails.crew_number !== null"
                  >{{ reportDetails.crew_number }} 名</span
                >
                <span v-else>---</span>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" class="mt-4 mb-4" vs-w="12">
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span class="report-heading-1-text">健康状態</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="start"
              vs-align="center"
              vs-lg="6" vs-sm="6" vs-xs="12"
            >
              <span
                class="report-body-text"
                :class="[
                  `text-${crewConditionsColor(reportDetails.crew_health)}`
                ]"
                >{{ crewConditions(reportDetails.crew_health) }}</span
              >
            </vs-col>
          </vs-row>
        </vx-card>
      </vs-col>
    </vs-row>
    <vx-card :noShadow="true">
      <vs-row vs-type="flex" class="mb-4">
        <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="10">
          <span class="report-heading-2-text">
            備考
          </span>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" class="mb-4">
        <vs-col vs-type="flex" vs-justify="start" vs-align="center" vs-w="12">
          <span class="report-body-text">{{
            reportDetails.note || "特になし"
          }}</span>
        </vs-col>
      </vs-row>
    </vx-card>
  </vx-card>
</template>

<script>
import { DateUtil } from "@/utils";
import ReportTimeline from "./ReportTimeline";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("vesselReportView");

export default {
  name: "CardVesselReport",
  components: {
    ReportTimeline
  },
  props: {
    reportId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      reportDetails: state => state.reportDetails
    }),
    crewConditions() {
      return function(value) {
        return value === 1 ? "良好" : "不良";
      };
    },
    crewConditionsColor() {
      return function(value) {
        return value === 1 ? "success" : "danger";
      };
    },
    toYMD() {
      return function(value) {
        return DateUtil.toYMD(value, "YYYY年MM月DD日 HH時mm分");
      };
    },
    heading() {
      return this.reportDetails.heading !== null
        ? `${Math.round(this.reportDetails.heading * 100) / 100}˚`
        : "---";
    },
    velocity() {
      return this.reportDetails.velocity !== null
        ? `${Math.round(this.reportDetails.velocity * 10) / 10} kn`
        : "---";
    },
    rpm() {
      return this.reportDetails.rpm !== null
        ? `${this.reportDetails.rpm} rpm`
        : "---";
    },
    crewNumber() {
      return this.reportDetails.crew_number !== null
        ? `${this.reportDetails.crew_number} 人`
        : "---";
    }
  }
};
</script>

<style lang="scss"></style>
